import React from 'react';
import { bool, shape, string } from 'prop-types';

const ConfirmedColor = ({
  className = '',
  notUseClass = false,
  color = '#217C74',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12.2507 5.24984H8.56982L9.12398 2.584L9.14148 2.39734C9.14148 2.15817 9.04232 1.9365 8.88482 1.779L8.26648 1.1665L4.42815 5.01067C4.21232 5.22067 4.08398 5.51234 4.08398 5.83317V11.6665C4.08398 12.3082 4.60898 12.8332 5.25065 12.8332H10.5007C10.9848 12.8332 11.399 12.5415 11.574 12.1215L13.3357 8.009C13.3881 7.87484 13.4173 7.73484 13.4173 7.58317V6.4165C13.4173 5.77484 12.8923 5.24984 12.2507 5.24984ZM12.2507 7.58317L10.5007 11.6665H5.25065V5.83317L7.78232 3.3015L7.13482 6.4165H12.2507V7.58317ZM2.91732 5.83317H0.583984V12.8332H2.91732V5.83317Z" fill="currentColor" />
  </svg>
);

ConfirmedColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default ConfirmedColor;
